import React from "react";
import { Icon } from "@mui/material";

function IconDisplay({ setting, styles = {} }) {
  const { fontSize = "medium", ...restStyles } = styles;
  return (
    <Icon sx={{ ...restStyles }} fontSize={fontSize}>
      {setting.field_value}
    </Icon>
  );
}

export default IconDisplay;
